<template>
	<div>
		<div class='chat single-message'>	
			<Sticky 
				v-bind:offset='0.5'
				triggerClass='step'
				ActiveClass='entered'
				:once='true'
				v-on:enterFn="handleEnterFn">

				<!-- sticky graphic -->
				<template v-slot:sticky>
					
				</template>
				
				<template v-slot:steps>
					<div class="chat-messages">
						<div 
							v-for="(bericht, index) in gesprek"
							:key="index + '-bericht'">

							<div
								v-if="bericht.other || bericht.other_img" 
								class="step chat-message inline other">
								<p v-if="bericht.other" v-html="bericht.other"></p>
								<img 
									v-if="bericht.other_img" 
									:class="isEmoticon(bericht.other_img)"
									:src='require("@/assets/images/" + bericht.other_img)' 
									alt="" />
							</div>

							<div 
								v-if="bericht.stick_around" 
								class="step chat-message inline other stick-around">
								<p v-if="bericht.other" v-html="bericht.other"></p>
								<img 
									v-if="bericht.other_img" 
									:class="isEmoticon(bericht.other_img)"
									:src='require("@/assets/images/" + bericht.other_img)' 
									alt="" />
							</div>


							<div 
								v-if="bericht.me || bericht.me_img"
								class="step chat-message inline me">
								<p v-if="bericht.me" v-html="bericht.me"></p>
								<img 
									v-if="bericht.me_img" 
									:class="isEmoticon(bericht.me_img)"
									:src='require("@/assets/images/" + bericht.me_img)' 
									alt="" />
							</div>

							<div 
								v-if="bericht.stick_around_me" 
								class="step chat-message me inline stick-around">
								<p v-if="bericht.me" v-html="bericht.me"></p>
								<img 
									v-if="bericht.me_img" 
									:class="isEmoticon(bericht.me_img)"
									:src='require("@/assets/images/" + bericht.me_img)' 
									alt="" />
							</div>
						</div>
					</div>
				</template>
			</Sticky>
		</div>


	</div>
</template>

<script>
	import Sticky from '../sticky';	

	export default {
		name: 'Chat',
		props: ['gesprek', 'header'],
		components: {
			Sticky
		},
		data() {
			return {
				currentNum: null
			};
		},
		mounted() {
		},
		methods: {
			randomNr(min, max) {
				return Math.floor(Math.random() * max) + min;
			},
			plusOrMinus() {
				return Math.random() < 0.5 ? -1 : 1;
			},
			handleEnterFn(el) {
				if (el.classList.contains("stick-around")) {
					document.querySelector(".knd-story").appendChild(el);
					el.classList.add("floating");
					let f = 1;
					el.querySelector("img") !== null ? f = .3 : f = 1;

					setTimeout(() => {
						el.classList.add("fade");
						const x = this.randomNr(0, (window.innerWidth * 0.3)) * this.plusOrMinus();
						const y = this.randomNr(0, (window.innerHeight * 0.4)) * this.plusOrMinus();
						const s = this.randomNr((2 * f), (3 * f));
						el.style.transform = "translate(" + x + "px, " + y + "px) scale(" + s + ") translateZ(0)";
					}, 10);	
				}

				this.currentNum = +el.dataset.index + 1;
			},
			isEmoticon(img) {
				console.log(img);
				if (img.includes("emoticon")) {
					return "emoticon";
				}
			}
		}
	}
</script>